module.exports = {
      id: "slider-right-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#slider-right-arrow",
      toString: function () {
        return this.url;
      }
    }